import { render, staticRenderFns } from "./SharePerDepartment.vue?vue&type=template&id=767c9881&scoped=true&"
import script from "./SharePerDepartment.vue?vue&type=script&lang=js&"
export * from "./SharePerDepartment.vue?vue&type=script&lang=js&"
import style0 from "./SharePerDepartment.vue?vue&type=style&index=0&id=767c9881&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c9881",
  null
  
)

export default component.exports